import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  IDestinatarioNaoNotificado,
  INotificacaoBloqueio,
  MotivoNaoNotificado,
} from 'src/app/modules/shared/interfaces/notificacao-bloqueio.interface';

/**
 * `aviso` antecede o bloqueio (o usuário confirma no "Ok" e só então a transição é
 * disparada); `resultado` é exibida depois, com o desfecho do envio.
 */
export type ModoNotificacaoBloqueio = 'aviso' | 'resultado';

/**
 * PBI 105365 — modal do bloqueio de veículo, nos dois momentos do fluxo: o aviso de que
 * a notificação será enviada aos órgãos institucionais e, após a transição, a confirmação
 * de que foi enviada.
 *
 * `notificacao` é opcional e só faz sentido no modo `resultado`: chega apenas quando o
 * backend devolve o bloco aditivo `notificacaoBloqueio` (§2.6).
 */
@Component({
  selector: 'app-modal-notificacao-bloqueio',
  templateUrl: './modal-notificacao-bloqueio.component.html',
  styleUrls: ['./modal-notificacao-bloqueio.component.scss'],
})
export class ModalNotificacaoBloqueioComponent {
  readonly modalTitle = 'Notificação de bloqueio';

  /** Texto obrigatório do critério de aceite — não alterar. */
  readonly mensagemAviso =
    'Uma notificação sobre o bloqueio será enviada para os órgãos institucionais responsáveis';

  readonly mensagemResultado =
    'Uma notificação sobre o bloqueio foi enviada para os órgãos institucionais responsáveis';

  modo: ModoNotificacaoBloqueio = 'resultado';

  notificacao?: INotificacaoBloqueio;

  readonly motivoDescricao: Record<MotivoNaoNotificado, string> = {
    ENDERECO_AUSENTE: 'Nenhum endereço configurado',
    ENDERECO_INVALIDO: 'Endereço com formato inválido',
    FALHA_PROVEDOR: 'Falha no envio pelo provedor de e-mail',
  };

  constructor(
    public dialogRef: MatDialogRef<ModalNotificacaoBloqueioComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.modo = this.data?.modo ?? 'resultado';
    this.notificacao = this.data?.notificacao;
  }

  get mensagem(): string {
    return this.modo === 'aviso' ? this.mensagemAviso : this.mensagemResultado;
  }

  /** No aviso o botão confirma o bloqueio; no resultado apenas encerra. */
  get textoBotao(): string {
    return this.modo === 'aviso' ? 'Ok' : 'Fechar';
  }

  get envioParcial(): boolean {
    return this.notificacao?.resultado === 'PARCIALMENTE_ENVIADA';
  }

  get naoNotificados(): IDestinatarioNaoNotificado[] {
    return this.notificacao?.naoNotificados ?? [];
  }

  /**
   * Devolve `true` para quem abriu a modal: é o que autoriza o bloqueio no modo `aviso`.
   * Fechar por ESC ou clique fora devolve `undefined` e cancela.
   */
  close(): void {
    this.dialogRef.close(true);
  }
}
